import request from "@/api/request";
//查询商品分类
export function getStoreTypeList() {
  return request({
    url: `/app/shop/option`,
    method: "get",
  });
}
// 查询商品列表
export function getStoreList(data1, data2) {
  return request({
    url: `/app/shopAdmin/appShopList?page=${data1.page}&size=${data1.size}`,
    method: "post",
    data: data2,
  });
}
// 查询订单列表
export function getOrderLists(data1, data2) {
  return request({
    url: `/app/shopOrder/orderList?page=${data1.page}&size=${data1.size}`,
    method: "post",
    data: data2,
  });
}
// 查询支付类型
export function getPayTypeAll() {
  return request({
    url: `/app/payType/getPayTypeAll`,
    method: "get",
  });
}
// 商品详情
export function getShopAdminModel(data) {
  return request({
    url: `/app/shopAdmin/getShopAdminModel?id=${data.id}&card=${data.meCardNum}&userId=${data.userId}`,
    method: "get",
  });
}
// 提交订单
export function addShopOrder(data1, data2, data3) {
  return request({
    url: `/app/shopOrder/addShopOrder?payId=${data1}&code=${data3}`,
    method: "post",
    data: data2,
  });
}
// 查询商户绑定账号列表
export function getUserPayList(data) {
  return request({
    url: `/app/payList/getUserPayList?payListType=${data}`,
    method: "get",
  });
}
// 查询客服信息
export function shopCustomerModel(data, card) {
  return request({
    url: `/app/shopCustomer/shopCustomerModel?userId=${data}&card=${card}`,
    method: "get",
  });
}

// 短信验证码
export function VerificationCode(data) {
  return request({
    url: `/app/shopOrder/VerificationCode?phone=${data}`,
    method: "get",
  });
}

// 验证短信验证码
export function VerificationCoding(phone, code) {
  return request({
    url: `/app/shopOrder/VerificationCoding?phone=${phone}&random=${code}`,
    method: "get",
  });
}

// 获取轮播信息
export function carouselImageModelList(data, card) {
  return request({
    url: `/app/shopSettings/carouselImageModelList?userId=${data}&card=${card}`,
    method: "get",
  });
}
